import React from 'react'

import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import ServicesSection from '../components/servicesSection';


export default function Searvices() {

    const {email} = useParams();
       
    return (
        <>
                <InactivityLogout>
                <Header searchterm={email} />
                <ServicesSection searchterm={email} />
                </InactivityLogout>
        </>
    );
}